var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"externalLink"},[_c('h3',{staticClass:"py-title col-w tx-c"},[_vm._v(_vm._s(_vm.systemConfig.BisWebSiteName))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-w py-background ub ub-ae ub-pc"},[_c('img',{attrs:{"src":require("../login/img/style.png")}})])
}]

export { render, staticRenderFns }